import React, { useEffect, useState } from "react";
import { X } from "react-feather";
import "./GenericFloatingBanner.css";

export default function GenericFloatingBanner({
  message = "",
  title = "Success",
  type = "success",   // success | error | info | warning
  duration = 3000,
  onClose = () => {}
}) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!duration) return;

    const timer = setTimeout(() => {
      setVisible(false);
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  if (!visible) return null;

  return (
    <div className={`gfb-container gfb-${type}`}>
      {/* Close Button */}
      <button className="gfb-close-btn" onClick={() => { setVisible(false); onClose(); }}>
        <X size={16} />
      </button>

      <div className="gfb-left">
        {/* Success Icon */}
        {type === "success" && <div className="gfb-icon success-icon">✔</div>}
        {type === "error" && <div className="gfb-icon error-icon">✖</div>}
        {type === "info" && <div className="gfb-icon info-icon">ℹ</div>}
        {type === "warning" && <div className="gfb-icon warning-icon">!</div>}
      </div>

      {/* Text content */}
      <div className="gfb-text">
        <div className="gfb-title">{title}</div>
        <div className="gfb-message">{message}</div>
      </div>
    </div>
  );
}
